import React from 'react'
import { Link, useHistory } from "react-router-dom";

const GameCards = () => {
  const navigate = useHistory();
  const handleRedirect = (path) => {
    navigate.push(path);
  };
  return (
    <div >
      <div className="homepage-game-cards">
        <div className="homepage-game-cards-grid-1">
          

          <button className='sports-home-gamecard' onClick={() => handleRedirect("/casino/sports")}>
            <img className='sports-home-gamecard-img' src='/assets/bcimages/bchome/sports-game-card.webp' />
            <div className='casino-home-gamecard-contant'>
              <div className='casino-home-gamecard-top'>
                <img style={{ height: "2rem", width: "2rem", flex: "none" }} src='/assets/bcimages/bchome/sports-home-gamecard.svg' />
                <span className="text-sm ml-0.5 sm:text-2xl">SPORTS</span>
              </div>
              <div className="casino-home-gamecard-bottom">
                Bet on Football, Cricket, NFL, eSports & over 80 sports!
              </div>
            </div>
          </button>
          <button className='casino-home-gamecard' onClick={() => handleRedirect("/casino")}>
            <img className='casino-home-gamecard-img' src='/assets/bcimages/bchome/casino-game-card.webp' />
            <div className='casino-home-gamecard-contant'>
              <div className='casino-home-gamecard-top'>
                <img style={{ height: "2rem", width: "2rem", flex: "none" }} src='/assets/bcimages/bchome/casino-home-gamecard.svg' />
                <span className="text-sm ml-0.5 sm:text-2xl">CASINO</span>
              </div>
              <div className="casino-home-gamecard-bottom">
                Dive into our in-house games, live casino and slots
              </div>
            </div>
          </button>
        </div>

        <div className='homepage-game-cards-grid-2'>
          <button className='lottery-home-gamecard' onClick={() => handleRedirect("/providers/300")}>
            <img className='lottery-home-gamecard-img' src='/assets/images/bccrash.png' />
            <div className='lottery-home-gamecard-span'>
              <img style={{ height: "1.5rem", width: "1.5rem", flex: "none" }} src='/assets/bcimages/bchome/lottery-home-gamecard.svg' />
              <span className="text-sm ml-0.5 sm:text-2xl">SPRIBE</span>
            </div>
          </button>
          <button onClick={() => handleRedirect("/casino/sports")} style={{ backgroundImage: "linear-gradient(to left, rgb(80, 65, 48), transparent 75%)" }} className='lottery-home-gamecard'>
            <img className='lottery-home-gamecard-img' src='/assets/images/live-card.png' />
            <div className='lottery-home-gamecard-span'>
              <img style={{ height: "1.5rem", width: "1.5rem", flex: "none" }} src='/assets/bcimages/bchome/racing-home-gamecard.svg' />
              <span className="text-sm ml-0.5 sm:text-2xl">LIVE</span>
            </div>
          </button>
          <button onClick={() => handleRedirect("/casino/slots")} style={{ backgroundImage: "linear-gradient(to left, rgb(45, 79, 49), transparent 75%)" }} className='lottery-home-gamecard'>
            <img className='lottery-home-gamecard-img' src='/assets/images/bcslots.png' />
            <div className='lottery-home-gamecard-span'>
              <img style={{ height: "1.5rem", width: "1.5rem", flex: "none" }} src='/assets/bcimages/bchome/updown-home-gamecard.svg' />
              <span className="text-sm ml-0.5 sm:text-2xl">SLOTS</span>
            </div>
          </button>
          <button onClick={() => handleRedirect("/casino/live-casino")} style={{ backgroundImage: "linear-gradient(to left, rgb(71, 56, 111), transparent 75%)" }} className='lottery-home-gamecard'>
            <img className='lottery-home-gamecard-img' src='/assets/images/ezugi-live.png' />
            <div className='lottery-home-gamecard-span'>
              <img style={{ height: "1.5rem", width: "1.5rem", flex: "none" }} src='/assets/bcimages/bchome/bingo-home-gamecard.svg' />
              <span className="text-sm ml-0.5 sm:text-2xl">EZUGI</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}

export default GameCards
